import React from 'react';
import { ItineraryTypes } from '../types';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import { HeaderCollapsible } from 'ui/HeaderCollapsible';
import { HtmlStringRenderer } from 'components/HtmlStringRenderer';
import { DocumentLinks } from 'ui/DocumentLinks';

interface ItemNotesAndAttachmentsProps {
  notes: ItineraryTypes['ItineraryItem']['notes'];
  uploads: ItineraryTypes['ItineraryItem']['uploads'];
}

export const ItemNotesAndAttachments = (props: ItemNotesAndAttachmentsProps) => {
  const params = useDynamicParameters();
  const { ITINERARY_MANAGER_BASE_URL } = params.dynamicParameters;

  const files = props.uploads.filter(u => u.fileType === 'file') as ItineraryTypes['ItineraryFileUpload'][];
  return (
    <>
      {props.notes.length >= 1 && (
        <HeaderCollapsible title="Notes">
          <div>
            {props.notes.map((note, idx) => {
              return (
                <HtmlStringRenderer 
                  key={note.uuid}
                  content={note.text}
                  className="m-0 font-hurmegeometric-sans text-13px text-flint"
                  fallbackComponent="p"
                />
              );
            })}
          </div>
        </HeaderCollapsible>
      )}
      {files.length >= 1 && (
        <HeaderCollapsible title="Attachments" childrenClassname="mt-3 mb-[40px]">
          <DocumentLinks
            documents={files}
            baseUrlPath={`${ITINERARY_MANAGER_BASE_URL}/viewer/v1/media/`}
          />
        </HeaderCollapsible>
      )}
    </>
  );
};
